import { Component, Input, ViewChild, ViewChildren, QueryList } from '@angular/core';

import { BaseFormList, MessageService } from '../../../core';
import { RegiaoCidade } from './regiao-cidade';
import { Cidade, TypeaheadCidadeComponent } from '../../cidade';
import { RegiaoCidadeSubRegiaoComponent } from './sub-regiao';
import { RegiaoCidadePopulaModalComponent } from './popula-modal';

@Component({
    selector: 'sgt-regiao-cidade',
    templateUrl: './regiao-cidade.component.html',
    styleUrls: ['./regiao-cidade.component.less']
})
export class RegiaoCidadeComponent implements BaseFormList<RegiaoCidade> {
    @Input() entities: RegiaoCidade[];

    @ViewChild('regiaoCidadeSubRegiaoModal') regiaoCidadeSubRegiaoModal: RegiaoCidadeSubRegiaoComponent;
    @ViewChild('regiaoCidadePopulaModal') regiaoCidadePopulaModal: RegiaoCidadePopulaModalComponent;
    @ViewChildren('typeaheadCidade') typeaheadsCidades: QueryList<TypeaheadCidadeComponent>;

    constructor(private messageService: MessageService) { }

    /** Ao alterar a cidade no typeahead */
    onTypeaheadChangeCidade(entity: RegiaoCidade, cidade: Cidade) {
        if (cidade) {
            entity.idCidade = cidade.id;
        } else {
            entity.idCidade = null;
        }
    }

    insert() {
        const entity = new RegiaoCidade();
        this.entities.push(entity);

        setTimeout(() => this.setFocusInsertCidade(), 200);
    }

    /** Seta o foco no typeahead da cidade ao inserir uma nova cidade */
    private setFocusInsertCidade() {
        if (!this.typeaheadsCidades) {
            return;
        }
        // Obtendo o último typeahead para setar o foco
        const typeaheadCidade = this.typeaheadsCidades.last;
        if (typeaheadCidade) {
            typeaheadCidade.setFocus();
        }
    }

    delete(index: number) {
        this.messageService.confirm('Deseja realmente excluir essa cidade?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
            }
        });
    }

    /** Verifica se as cidades da região estão válidas */
    isValid(): boolean {
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            if (!entity.idCidade) {
                continue;
            }
            const count = this.entities.filter(entityFilter => entityFilter.idCidade && entityFilter.idCidade === entity.idCidade).length;
            if (count > 1) {
                this.messageService.info(`A cidade ${entity.cidade.nome} já está adicionada. Remova ou altere a cidade duplicada`, 'Não é possível adicionar duas cidades iguais');
                return false;
            }
        }
        return true;
    }

    /** Resolve as cidades presentes na região */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo as cidades do array que não possuirem o id da cidade informado
        for (let i = this.entities.length; i--; ) {
            const entity = this.entities[i];

            // Resolvendo as sub-regiões da cidade
            this.regiaoCidadeSubRegiaoModal.resolve(entity);

            if (!entity.idCidade) {
                this.entities.splice(i, 1);
            }
        }
    }

    /** Abre o modal de sub-regiões */
    openSubRegioesModal(entity: RegiaoCidade) {
        this.regiaoCidadeSubRegiaoModal.open(entity);
    }

    /** Abre o modal para adicionar cidades */
    openPopulaCidadeModal() {
        this.regiaoCidadePopulaModal.open();
    }
}
